import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/cookie-consent/cookie-consent.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/providers/picture-viewer-provider/picture-viewer-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/providers/posthog/posthog-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/apps/web/src/providers/theme-provider/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/providers/toast-provider/toast-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/layouts/root/root-layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../../app/fonts/opensans.ttf\",\"weight\":\"100 900\"}],\"variableName\":\"font\"}");
